import Axios, { AxiosResponse } from 'axios';
import { BASE_API_PATH } from '../enum/base.enum';
import { CashbackConfig } from '../app.reducer';

export const PromoService = {
    getCashBackDetails: (checkoutId: string): Promise<AxiosResponse<CashbackConfig>> => {
        return Axios.get(`${BASE_API_PATH}/cashback?checkoutId=${checkoutId}`);
    }
};
